import { memo, useCallback } from 'react';
import { BzButton, BzCard, BzHeading, BzInputText, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { Container, Row, Col, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { handleModal } from '../../redux/actions/modals';
import { toastConfig } from '../../redux/actions/toast';
import { getGlobalWatchlistScrips } from '../../redux/actions/watchlist';
import { filterSpCharsAndSpacesOut, getAppInfoData } from '../../utils/global_functions';
import { APP_INFO_DEFAULT_VALUES, APP_INFO_PARAMS, DONT_MISS_WATCHLIST_NAME, MY_HOLDINGS_WATCHLIST_NAME } from '../../utils/global_variables';
import { _checkForSpecialChars, _creatingCustomWatchlist, _emptyWatchlist, _watchlistNameAlreadyExist } from '../../controllers/watchlist';


const CreateWatchlistModal = ({ setCustomNewWatchlistName, createdWatchlistName, setCreatedWatchlistName, ...props }) => {




    const modals = useSelector(state => state?.modals?.modals);
    const { appInfo } = useSelector(state => state.appInfo);
    const { isWatchlistPresent, globalWatchlists, watchlists } = useSelector(state => state.watchList);

    const watchlistsCopy = watchlists?.length > 0 && watchlists?.filter(eachWatchlist => eachWatchlist?.sWatchListName?.toLowerCase() !== DONT_MISS_WATCHLIST_NAME && eachWatchlist?.sWatchListName?.toLowerCase() !== MY_HOLDINGS_WATCHLIST_NAME);

    const maxWatchlist = getAppInfoData(APP_INFO_PARAMS.APP_MAX_PROFILE_COUNT,APP_INFO_DEFAULT_VALUES.APP_MAX_PROFILE_COUNT);

    const dispatch = useDispatch();

    const handleClose = useCallback(() => {
        setCreatedWatchlistName('');
        dispatch(handleModal([{ 'CREATE_WATCHLIST_MODAL': false }]));
    }, [dispatch]);


    const onCreateNewCustomWatchlist = useCallback((customWatchlistName) => {

        let customWatchlistConditions = _creatingCustomWatchlist(watchlists, customWatchlistName, globalWatchlists, maxWatchlist);
        if (!customWatchlistConditions.status) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: customWatchlistConditions.message }));
        } else {
            dispatch(handleModal([{ 'CREATE_WATCHLIST_MODAL': false }, { 'SCRIPT_RECOMMENDATIONS_MODAL': true }]));
            setCustomNewWatchlistName(customWatchlistName);
        }

    }, [dispatch, watchlists, setCustomNewWatchlistName, maxWatchlist, globalWatchlists]);

    const createCustomWatchlistOnClickHandler = () => {
        onCreateNewCustomWatchlist(createdWatchlistName);
    };


    const globalWatchlistTemplateModalToggle = useCallback((selectedGlobalWatchlist) => {

        let nameExists = _watchlistNameAlreadyExist(watchlists, filterSpCharsAndSpacesOut(selectedGlobalWatchlist?.sWatchListName));
        let isWatchlistEmpty = _emptyWatchlist(selectedGlobalWatchlist);
        if (!nameExists?.status) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: nameExists?.message }));
        } else if (!isWatchlistEmpty?.status) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: isWatchlistEmpty?.message }));
        } else if (isWatchlistEmpty?.status) {
            selectedGlobalWatchlist['sWatchListName'] = filterSpCharsAndSpacesOut(selectedGlobalWatchlist?.sWatchListName);
            dispatch(getGlobalWatchlistScrips(selectedGlobalWatchlist));
            handleClose();
            dispatch(handleModal([{ "GLOBAL_WATCHLIST_SCRIPT_MODAL": true }]));
        } else {
        }
    }, [handleClose, watchlists, dispatch]);


    const handleChange = (event) => {
        const { value } = event.target;
        if (!_checkForSpecialChars(value)?.status) {
            setCreatedWatchlistName(value);
        }

    };


    return (
        <BzModal data-testid="watchlist-create-dialog" size='lg' show={modals['CREATE_WATCHLIST_MODAL']} onHide={handleClose} className='p-3'>
            <BzModalHeader className='bdr-none'>
                {/* Ameersha N - 22-11-2023 : BT-95888 Create Watchlist :issue added classname to remove border */}
                <Container fluid className='p-0 py-4'>
                    <Row className='g-0'>
                        <Col md={10} className='d-flex justify-content-start align-self-center'>
                            <BzHeading data-testid="guest-landing-hero" className='font-medium font-size12 color-text'>Let's create your {watchlistsCopy?.length === 0 && isWatchlistPresent ? 'first' : null} watchlist!</BzHeading>
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-self-center'>
                            <BzButton data-testid="watchlist-createwatchlist-modal-skipbutton" onClick={handleClose} className='btn btn-md btn-outline btn-rounded'>Skip</BzButton>
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col className='d-flex justify-content-start'>
                            <div className='font-regular font-size5 color-text'>Keep watching them to find right opportunities.</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>

            <BzModalBody>
                <Row className='g-0 pb-3'>
                    <Col>
                        <BzHeading className='font-medium font-size5 color-text'>Choose from these top picks</BzHeading>
                    </Col>
                </Row>

                <div className='watchlist-card-wrap'>
                    {globalWatchlists?.map((each) =>
                        <BzCard className='watchlist-card cursor-pointer' data-testid="watchlist-createwatchlist-modal-select-tenant-watchlistcard" key={each.id} onClick={() => { globalWatchlistTemplateModalToggle(each); }}>
                            <Row className='g-0'>
                                <Col className='watchlist-img'>
                                    <div className='watchlist-img-0'></div>
                                </Col>
                            </Row>
                            <Row className='g-0 mt-2'>
                                <Col className='watchlist-info'>
                                    <div className='font-regular font-size3 color-subtext'>TOP 20</div>
                                    <div className='font-medium font-size3 color-text'>{filterSpCharsAndSpacesOut(each.sWatchListName)}</div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col md={3} className='d-flex justify-content-start align-items-center'>
                                    <div className='icon-12 icon-dark icon-subscribers'></div>
                                </Col>
                                <Col md={9} className='d-flex justify-content-end align-items-center'>
                                    <div className='font-regular font-size2 color-subtext'>{JSON?.parse(each?.sSettings)?.subCount} Subscribers</div>
                                </Col>
                            </Row>
                        </BzCard>
                    )}
                </div>

            </BzModalBody>

            <BzModalFooter className='bdr-none create-own-watchlist'>
                {/* Ameersha N - 22-11-2023 : BT-95888 Create Watchlist :issue added classname to remove border */}
                <Container fluid>
                    <form onSubmit={e => e.preventDefault()}>
                        <Row className='g-0'>
                            <Col>
                                <div className='fancyline'>
                                    <span className='font-medium font-size4 color-text'>Or you can create your own watchlist</span>
                                </div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col md={6} className='mx-auto'>
                                <InputGroup className='py-4'>
                                    <BzInputText data-testid="watchlist-createwatchlist-modal-inputname" maxLength='20' onChange={(e) => handleChange(e)} value={createdWatchlistName} className='font-regular color-text text-uppercase' placeholder='Name your watchlist' />
                                    <BzButton type='submit' data-testid="watchlist-createwatchlist-modal-createbutton" className='btn btn-md btn-primary text-capitalize' onClick={createCustomWatchlistOnClickHandler}>Create</BzButton>
                                </InputGroup>
                            </Col>
                        </Row>
                    </form>
                </Container>
            </BzModalFooter>

        </BzModal>

    );
};

export default memo(CreateWatchlistModal);